import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Website, UpsertWebsitePayload } from '../store/interfaces';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  constructor(
    private readonly http: HttpClient,
    @Inject('ecomBaseUrl') private url: string,
  ) {}

  getWebsites() {
    return this.http.get<Website[]>(`${this.url}backoffice/websites`, {
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
    });
  }

  upsertWebsite(website: UpsertWebsitePayload) {
    return this.http.put<Website>(`${this.url}backoffice/websites`, website, {
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
    });
  }

  deleteWebsite(id: string) {
    return this.http.delete<void>(`${this.url}backoffice/websites/${id}`, {
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
    });
  }

  getAccounts() {
    return this.http.get<any[]>(`${this.url}backoffice/accounts`, {
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
    });
  }
}
